module.exports = "/images/visa.png";